import React from 'react';

import { Box, Typography } from '@mui/material';

import { INCLUSION_ROW_GRID_TEMPLATE_COLUMNS } from './InclusionRow';

const HEADER_COLUMNS = ['Inclusion name', 'Type', 'Deal RRP', 'Asset value', 'Total value', 'RRP comparison', 'Action'];

export default function InclusionRowHeader() {
  return (
    <Box
      sx={{
        alignItems: 'center',
        bgcolor: 'grey.50',
        borderBottom: 1,
        borderBottomColor: 'divider',
        columnGap: 2,
        display: 'grid',
        gridTemplateColumns: INCLUSION_ROW_GRID_TEMPLATE_COLUMNS,
        px: 2,
        py: 1,
      }}
    >
      {HEADER_COLUMNS.map((label, index) => (
        <Typography
          key={label || index}
          variant="caption"
          color="text.secondary"
          fontWeight={700}
          sx={{ letterSpacing: 0.6, textTransform: 'uppercase' }}
        >
          {label}
        </Typography>
      ))}
    </Box>
  );
}
